import React, { useRef } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { BarChartHeader } from "./BarChartHeader";
import { BarChartCanvas } from "./BarChartCanvas";
import { useBarChartExport } from "./hooks/useBarChartExport";
import type { BarChartData } from "@/lib/chat/parseBarChartBlock";

interface BarChartModalProps {
  open: boolean;
  onClose: () => void;
  data: BarChartData;
}

export const BarChartModal: React.FC<BarChartModalProps> = ({
  open,
  onClose,
  data,
}) => {
  const exportRef = useRef<HTMLDivElement>(null);
  const { exportPNG } = useBarChartExport(exportRef, data.title);

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="flex h-[90vh] w-[95vw] max-w-none flex-col gap-0 p-0 sm:rounded-2xl [&>button:last-child]:hidden">
        <div ref={exportRef} className="flex flex-col flex-1 min-h-0">
          <BarChartHeader
            title={data.title}
            mode="expanded"
            onDownload={exportPNG}
            onToggleExpand={onClose}
          />
          <div className="flex-1 min-h-0 bg-muted/20">
            <BarChartCanvas data={data} height="fill" mode="expanded" />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
